import React, { useEffect, useState, useRef } from "react";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import commonStyle from "../../../style/commonStyle.module.css";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import useDocumentTitle from "../../../useDocumentTitle";
import ScreenTitle from "../../../components/ScreenTitle";
import { NavLink } from "react-router-dom";
import { SimpleDialog } from "../../../components/dialogs";
import { useDispatch, useSelector } from "react-redux";
import QuestionsForm from "./QuestionForm";
import { addNewQuestion } from "../../../api/webContentRequets";


export default function NewQuestion() {
  useDocumentTitle("Add New Question");
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const { userInfo } = useSelector((state) => state.userLogin);
  const config = {
    headers: {
      "Content-type": "application/json",
      Authorization: `Bearer ${userInfo.data.token}`,
     
    },
  };

const [saveStatus, setSaveStatus] = useState({
  loading: false,
  success: false,
  error: ""
})

  useEffect(() => {
    // dispatch(brandOptionsListRequest());
  }, [dispatch]);

  const initialvalues = {
    questionType: "",
    questionName: "",
    answer: "",
  };

  //  dialog
  const handleSave = async (values) => {
   
    let postValues = {
      questionName: values.questionName,
      type: values.questionType.value,
      answer: values.answer
    }
    try {
      setDialog(true);
      setSaveStatus({...saveStatus, loading: true})
      const responseData = await addNewQuestion(postValues, config, dispatch);
      if (responseData.data.success) {
        setSaveStatus({...saveStatus, loading: false, success: true})
       
      } else {
        throw responseData.data.message;
      }
    } catch (error) {
      setSaveStatus({...saveStatus, loading: false, error: error})
    }
  };
  const [dialog, setDialog] = useState(false);

  const closeDialogWithSuccess = () => {
    setDialog(false);
    navigate("/web-content/faq", { replace: true, from: location });
  };

  return (
    <div className={commonStyle.pageContainer}>
      <SimpleDialog
        title="Add New Question"
        successMessage="New question added successfully."
        isDialogOpen={dialog}
        closeDialog={() => setDialog(false)}
        loading={saveStatus.loading}
        loadingMessage="Processing request..."
        success={saveStatus.success}
        error={saveStatus.error}
        confirmAction={closeDialogWithSuccess}
      />

      <div className="w-full p-8">
        <Breadcrumbs aria-label="breadcrumb">
          <NavLink underline="hover" color="inherit" to="/">
            Home
          </NavLink>
          <NavLink underline="hover" color="inherit" to="/web-content/faq">
            FAQ
          </NavLink>
          <NavLink
            underline="hover"
            color="text.primary"
            to={`/web-content/faq/new`}
            aria-current="page"
          >
            New Question
          </NavLink>
        </Breadcrumbs>
        <ScreenTitle title="Add New Question" />

        <QuestionsForm
          type="new"
          onSave={handleSave}
          initialValues={initialvalues}
        />
      </div>
    </div>
  );
}
